module.exports = __webpack_public_path__ + "static/unternehmen-img-c228600f4c3245a48bbdffc5b0593b56.png";